// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"shimmer_shimmer__RAn6a"};